<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Menu</h2>
    </div>
    <tabs-default :restaurantId="restaurantId"></tabs-default>
  </div>
</template>

<script>
import TabsDefault from './tabs/TabsDefault.vue'
import vSelect from 'vue-select'

export default{
  components: {
    TabsDefault,
    'v-select': vSelect
  },
  data () {
    return {
      user_group: {label: 'Select a restaurant', value: 0},
      user_group_options: [],
      restaurantId: -1,
      tab_data: {}
    }
  },
  watch: {
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.restaurantId = this.selectedRestaurant.id
      }
    }
  },
  methods: {
  },
  mounted () {
    this.restaurantId = this.selectedRestaurant.id
  },
  computed: {
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  }
}
</script>
<style>
  .vs--single.vs--open .vs__selected{
    position: initial;
  }
</style>
